const Protocal = function (obj) {
    this._init_(obj);
};

Protocal.prototype = {
    constructor: Protocal,
    _init_: function (obj) {
        if (obj) {
            this.fp = obj.fp;
            this.qos = obj.qos;
            this.msgType = obj.msgType;
            this.messageContent = obj.messageContent;
        }
    },
    toString: function () {
        return JSON.stringify(this);
    }
};

export default Protocal;
